import type { SKUSelectionErrorMessageProps } from '@src/components/SKUSelectionErrorMessage/SKUSelectionErrorMessage.props'

export const SKUSelectionErrorMessageDefaults: SKUSelectionErrorMessageProps = {
  errorMessage: 'Please make all selections to continue',
}
